import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LOGOUT_SUCCESS, LOAD_APPS } from '@core/store/actions';
import { AppState } from '@core/store/app.reducers';
import { Store } from '@ngrx/store';
import { GeneralService } from '@shared/services/general.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit {
  constructor(private store: Store<AppState>, private router: Router, public generalService: GeneralService) {}

  ngOnInit() {}

  logout() {
    this.store.dispatch(LOGOUT_SUCCESS());
    //   this.store.dispatch(LOAD_APPS());
    this.router.navigate(['/logout']);
  }

  changeSplitPane(splitPaneState: boolean): void {
    this.generalService.splitPaneState = splitPaneState;
  }
}
